const characterSpeech = (target, count, delay) => {
  delay = delay || 300
  let temp = count - 1
  if (temp >= 0) {
    target.speaking = true;
    setTimeout(() => {
      target.speaking = false;
      setTimeout(() => {
        characterSpeech(target, temp, delay)
      }, delay)
    }, delay)
  }
}

export {
  characterSpeech
}



// WEBPACK FOOTER //
// ./src/assets/js/utils/characterSpeech.js